import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "closeable", "closeButtonAriaLabel", "compact", "distance", "onClose"];
import styled from 'foundations-theming/utils';
import { CloseButton } from '../CloseButton';
import { toShorthandSize } from '../../utils/tShirtSizes';
import { TileContextProvider, defaultTileContext } from './TileContext';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { DISTANCE_SIZES } from '../../utils/distance';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const compactTileContext = {
  compact: true
};
const StyledTile = styled.div.withConfig({
  displayName: "Tile__StyledTile"
})(({
  $cssStyles,
  $distance,
  theme
}) => {
  return Object.assign({
    '& + &': {
      marginTop: $distance ? undefined : theme.space['400']
    },
    position: 'relative',
    borderRadius: theme.borderRadius['transitional-container-alt'],
    backgroundColor: theme.color['fill-surface-default'],
    border: `${theme.borderWidth[100]} solid ${theme.color['border-core-subtle']}`,
    marginBlock: $distance ? theme.space[DISTANCE_SIZES[toShorthandSize($distance)]] : undefined
  }, $cssStyles);
});
const CloseButtonWrapper = styled.div.withConfig({
  displayName: "Tile__CloseButtonWrapper"
})(({
  theme
}) => {
  return {
    top: theme.space['300'],
    right: theme.space['300'],
    position: 'absolute'
  };
});
export const Tile = _ref => {
  let {
      children,
      closeable,
      closeButtonAriaLabel,
      compact,
      distance,
      onClose
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(TileContextProvider, {
    value: compact ? compactTileContext : defaultTileContext,
    children: /*#__PURE__*/_jsxs(StyledTile, Object.assign({
      $cssStyles: cssStyles,
      $distance: distance
    }, domProps, {
      children: [closeable ? /*#__PURE__*/_jsx(CloseButtonWrapper, {
        children: /*#__PURE__*/_jsx(CloseButton, {
          size: "medium",
          onClick: onClose,
          color: "icon-core-subtle",
          insetBlockStart: "100",
          insetInlineEnd: "100",
          "aria-label": closeButtonAriaLabel
        })
      }) : null, children]
    }))
  });
};
Tile.displayName = 'Tile';